import * as React from "react";
import { SVGProps } from "react";
const SvgCheckmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#checkmark_svg__a)">
      <path
        d="M6 12.414 2.292 8.707l1.415-1.414L6 9.586l6.293-6.293 1.415 1.414L6 12.414Z"
        fill="#3EAC40"
      />
    </g>
    <defs>
      <clipPath id="checkmark_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCheckmark;
